import axios from "axios";

const containerTypes = ['grid', 'group', 'list', 'object'];

const getFormStatus = (item) => {
    if (item.isUnpub) {
        return 'Unpublished';
    } else if (!item.hasPub) {
        return 'Draft';
    } else if (item.draft?.data) {
        return 'Draft';
    } else {
        return 'Published';
    }
};
/*const blobToBase64 = (file) => {
    console.log('[blobToBase64] file', file);
    let reader = new FileReader();
    reader.readAsDataURL(file);
    reader.onload = (e) => {
        console.log('[blobToBase64] e', e);
        console.log('[blobToBase64] reader.result', reader.result);
        return reader.result;
    };
};*/
// 获取图片file转base64
const blobToBase64 = (blob) => {
    return new Promise((resolve, _) => {
        const reader = new FileReader();
        reader.onloadend = () => resolve(reader.result);
        reader.readAsDataURL(blob);
    });
};


// Base64 转为 Blob
const base64ToBlob = (fileDataURL) => {
    //console.log('[base64ToBlob] fileDataURL', fileDataURL);
    let arr = fileDataURL.split(","),
        mime = arr[0].match(/:(.*?);/)[1],
        bstr = atob(arr[1]),
        n = bstr.length,
        u8arr = new Uint8Array(n);
    //console.log('[base64ToBlob] mime', mime);
    while (n--) {
        u8arr[n] = bstr.charCodeAt(n);
    }
    return new Blob([u8arr], { type: mime });
}

const fileAndBlobToCanvas = (fileDataURL, canvas) => {
    let img = new Image();
    img.src = fileDataURL;
    /*let canvas = document.createElement('canvas')
    if (!canvas.getContext) {
      alert('浏览器不支持canvas')
      return
    }*/
    let ctx = canvas.getContext('2d');
    //document.getElementById('container').appendChild(canvas);
    img.onload = () => {
        ctx.drawImage(img, 0, 0, img.width, img.height)
    }
}

const formatViewData = (data) => {

    //console.log('[formatViewData] data', data);

    const keys = Object.keys(data);
    if (keys.length > 0) {
        for (let i = 0; i < keys.length; i++) {
            const key = keys[i];
            //console.log('[formatViewData] key', key);
            if (key.indexOf('signature') === 0) {

                //console.log('[formatViewData] val', data[key]);

                const blob = base64ToBlob(data[key]);

                //console.log('[formatViewData] ', key, blob);

                data[key] = blob;
            }
        }
    }

    return data;
};
/* 
const formatFormData = (data, files) => {


    return new Promise((resolve, _) => {


        if (files && files.length > 0) {
            for (let i = 0; i < files.length; i++) {
                let file = files[i];
                data[file.key] = file.url;
            }
        }

        console.log('[formatFormData] data', data);

        let signatureKey = '';
        const keys = Object.keys(data);
        for (let i = 0; i < keys.length; i++) {
            let key = keys[i];
            if (key.indexOf('signature') === 0) {
                signatureKey = key;
                break;
            }
        }
        if (signatureKey && signatureKey.length > 0) {
            blobToBase64(data[signatureKey]).then((base64) => {

                console.log('[formatFormData] ', signatureKey, base64);
                data[signatureKey] = base64;

                resolve(data);
            });
        } else {

            resolve(data);
        }
    });

}; */

const formatFormData = (data, files, formSchema) => {


    if (files && files.length > 0) {
        let init = [];
        for (let i = 0; i < files.length; i++) {
            let file = files[i];
            if (file.part) {
                if (init.indexOf(file.key) < 0) {
                    init.push(file.key);
                    data[file.key] = [];
                }
                data[file.key].push(file.url);
            } else {
                data[file.key] = file.url;
            }
        }
    }

    let keys = Object.keys(data);


    for (let i = 0; i < keys.length; i++) {
        let key = keys[i];
        let schemaType = formSchema[key]?.type || '';
        if (key.indexOf('captcha') === 0 || schemaType === 'captcha') {
            delete data[key];
        } 
    }

    const price = tryFindPrice(data, formSchema);

    if (price > 0) {
        data = { ...data, ciPriceTotal: price };
    }

    return data;

};

const tryFindPrice = (data, formSchema) => {
    //console.log('[tryFindPrice] formSchema', formSchema);
    const priceInfo = getPirceInfo(formSchema);
    //console.log('[tryFindPrice] priceInfo', priceInfo);
    if(priceInfo.flag && priceInfo.pricetotal.flag && priceInfo.pricetotal.items.length> 0) {
        const path = priceInfo.pricetotal.items[0];
        const price = findFieldByPath(data, path);
        if(price) {
            return parseFloat(price);
        }
    }
    return 0;
};
const tryFindRedirectUrl = (formSchema) => {
    if(formSchema) {
        const redirectInfo = getRedirectInfo(formSchema);
        if(redirectInfo.flag && redirectInfo.redirect_url_do_not_change.flag && redirectInfo.redirect_url_do_not_change.items.length> 0) {
            //console.log('[tryFindRedirectUrl]', formSchema, redirectInfo.redirect_url_do_not_change.items[0], redirectInfo.redirect_url_do_not_change.items[0]?.default);
            return redirectInfo.redirect_url_do_not_change.items[0]?.default;
        }
    }
    return null;
};

const getUploadFiles = (data, formId, formSchema) => {

    let files = [];

    const keys = Object.keys(data);

    const fieldDict = getFormFields({schema: formSchema});
    for (let i = 0; i < keys.length; i++) {
        let key = keys[i];
        //let schemaType = formSchema[key]?.type || '';
        let schemaType = fieldDict[key]?.type || '';
        if (key.indexOf('image') === 0 || key.indexOf('file') === 0 || key.indexOf('signature') === 0 || schemaType === 'image' || schemaType === 'file' || schemaType === 'signature') {
            if (data[key]) {
                files.push({
                    key: key,
                    formId: formId,
                    url: '',
                    data: data[key]
                });

                //console.log('[getUploadFiles] key', key, data[key]);
            }
        } else if (key.indexOf('multifile') === 0 || key.indexOf("multiImage") === 0 || schemaType === 'multifile' || schemaType === 'multiImage') {
            //console.log('[getUploadFiles] key', key, data[key]);
            let items = data[key];
            if (items && items.length > 0) {
                for (let i = 0; i < items.length; i++) {

                    files.push({
                        key: key,
                        formId: formId,
                        part: true,
                        url: '',
                        data: items[i]
                    });
                }
            }
        }
    }

    return files;
};



const uploadFiles = (files) => {
    //console.log('[uploadFiles] files', files);
    const promises = files.map((file, index) => {
        const formData = new FormData();
        formData.append('file', file.data);
        formData.append('formId', file.formId);

        return axios.post('/api/upload-temp', formData)
            //.then(response => response.json())
            .then(data => {
                //console.log('File uploaded: data', data);
                //console.log('File uploaded: data.data', data.data);
                files[index].url = data.data;
            })
            .catch(error => console.error('Error uploading file:', error));
    });

    return Promise.all(promises); // 返回一个Promise，所有文件上传完毕后解决
};


const getFilesData = (schema, data) => {
    let files = [];
    if (schema) {
        const keys = Object.keys(schema);
        if (keys && keys.length > 0) {
            for (let i = 0; i < keys.length; i++) {
                let key = keys[i];
                let item = {
                    title: schema[key].label || schema[key].name,
                    files: []
                };
                if (data[key]) {

                    if (Array.isArray(data[key])) {
                        let items = data[key];
                        //console.log('[getFilesData] items', key, items);
                        for (let j = 0; j < items.length; j++) {
                            let url = items[j];
                            let array = url.split('/');
                            let file = {
                                name: decodeURIComponent(array[array.length - 1] || ''),
                                url: url
                            };
                            item.files.push(file);
                            //files.push(item);
                        }
                    } else {
                        let url = data[key];
                        let array = url.split('/');
                        let file = {
                            name: array[array.length - 1],
                            url: url
                        };
                        item.files.push(file);

                    }
                    //console.log('[getFilesData] item', key, item);
                }
                if(item.files.length > 0) {
                    files.push(item);

                }
            }
        }
    }
    //console.log('[getFilesData] files', files);
    return files;
};


const modifySchema = (schema) => {
    /* const keys = Object.keys(schema);
    if (keys && keys.length > 0) {
        for (let i = 0; i < keys.length; i++) {
            let key = keys[i].split('_')[0];
            if(key === 'phone') {
                console.log('[modifySchema] key', key);
                schema[keys[i]] = modifySchemaPhone(schema[keys[i]]);
            }
        }
    } */

    // append custom class
    const keys = Object.keys(schema);
    if (keys && keys.length > 0) {
        for (let i = 0; i < keys.length; i++) {
            let key = keys[i];
            let type = schema[key].type;
            //console.log('[modifySchema]', key, type);
            if(containerTypes.indexOf(type) > -1) {
                let classes = [];
                classes.push(`ci-form-${type}`);
                schema[key].class = classes;
            }
        }
    }
    return schema;
};

const modifySchemaPhone = (ele) => {

    if(ele) {
        ele.include = ['ca', 'us', 'gb', 'de', 'nl'];
    }

    return ele;

};
const checkFilesSchema = (fileSchema, imageSchema, signatureSchema, schema) => {

    const keys = Object.keys(schema);

    for (let i = 0; i < keys.length; i++) {
        const key = keys[i];
        if(schema[key]?.schema) {
            checkFilesSchema(fileSchema, imageSchema, signatureSchema, schema[key]?.schema);
        } else {

            let schemaType = schema[key]?.type || '';
            let sType = schema[key]?.builder?.type;
            if(key === 'Submit' || sType === 'submit') {
                delete schema[key];
            } else if (key.indexOf('captcha') === 0 || schemaType === 'captcha') {

                delete schema[key];
            } else if (key.indexOf('image') === 0 || key.indexOf('multiImage') === 0 || schemaType === 'image' || schemaType === 'multiImage') {

                imageSchema[key] = schema[key];

                delete schema[key];
            } else if (key.indexOf('signature') === 0 || schemaType === 'signature') {

                signatureSchema[key] = schema[key];

                delete schema[key];
            } else if (key.indexOf('file') === 0 || key.indexOf('multifile') === 0 || schemaType === 'file' || schemaType === 'multifile') {

                fileSchema[key] = schema[key];

                delete schema[key];
            }
        }
    }
};
//const priceFields = ['priceRadioGroup', 'priceTotal', 'priceCheckboxGroup', 'pricePayment', 'priceDonate', 'priceDonateSelect'];
const priceFields = ['pricetotal'];
const redirectFields = ['redirect_url_do_not_change'];
const getPirceInfo = (schema) => {
    let priceInfo = {
        flag: false,
        // priceRadioGroup: {
        //     flag: false,
        //     items: [],
        // },
        pricetotal: {
            flag: false,
            items: [],
        },
        // priceCheckboxGroup: {
        //     flag: false,
        //     items: [],
        // },
        // pricePayment: {
        //     flag: false,
        //     items: [],
        // },
        // priceDonate: {
        //     flag: false,
        //     items: [],
        // },
        // priceDonateSelect: {
        //     flag: false,
        //     items: [],
        // }
    };
    findPriceFields(priceInfo, schema, '');
    return priceInfo;
};
const findPriceFields = (priceInfo, schema, path) => {

    const keys = Object.keys(schema);

    for (let i = 0; i < keys.length; i++) {

        const key = keys[i];
        if(schema[key]?.schema) {
            let subPath = schema[key].type === 'object' ? `${path}|${key}` : path;
            findPriceFields(priceInfo, schema[key].schema, subPath);
        } else {
            let infoKey = '';
            let schemaType = schema[key]?.type || '';
            let sType = schema[key]?.builder?.type;
            if(priceFields.indexOf(schemaType) > -1) {
                infoKey = schemaType;
            } else if (priceFields.indexOf(sType) > -1) {                
                infoKey = sType;
            }

            //console.log('[findPriceFields] infoKey', infoKey);

            if(infoKey) {
                priceInfo.flag = true;
                //console.log(priceInfo, infoKey, priceInfo[infoKey]);
                priceInfo[infoKey].flag = true;
                priceInfo[infoKey].items.push(`${path}|${key}`);
            }
        }
    }

};
const getRedirectInfo = (schema) => {
    let redirectInfo = {
        flag: false,
        redirect_url_do_not_change: {
            flag: false,
            items: [],
        },
    };
    findRedirectFields(redirectInfo, schema, '');
    return redirectInfo;

};
const findRedirectFields = (redirectInfo, schema, path) => {

    const keys = Object.keys(schema);

    for (let i = 0; i < keys.length; i++) {

        const key = keys[i];
        if(schema[key]?.schema) {
            let subPath = schema[key].type === 'object' ? `${path}|${key}` : path;
            findRedirectFields(redirectInfo, schema[key].schema, subPath);
        } else {
            let infoKey = '';
            let schemaType = schema[key]?.type || '';
            let sType = schema[key]?.builder?.type;
            if(redirectFields.indexOf(schemaType) > -1) {
                infoKey = schemaType;
            } else if (redirectFields.indexOf(sType) > -1) {                
                infoKey = sType;
            }

            //console.log('[findPriceFields] infoKey', infoKey);

            if(infoKey) {
                redirectInfo.flag = true;
                redirectInfo[infoKey].flag = true;
                redirectInfo[infoKey].items.push(schema[key]);
            }
        }
    }

};
const findFieldByPath = (obj, path) => {
    if(path) {
        path = path.replace('|', '');
        let key = path.split('|')[0];
        if(obj[key]) {
            return findFieldByPath(obj[key], path.replace(key, ''));

        } else {
            return null;
        }
    } else {
        return obj;
    }
};
const setAttrValue = (obj, path, val) => {
    if(path) {
        path = path.replace('|', '');
        const arr = path.split('|');
        let key = arr[0];
        const keys = Object.keys(obj);
        if(keys.indexOf(key) > -1) {
            
            if(arr.length > 1) {
                setAttrValue(obj[key], path.replace(key, ''));
            } else {
                obj[key] = val;
            }
        }
    }
};
const fixPriceSchema = (builderObject) => {
	fixPriceTotalSchema(builderObject.schema);
    return builderObject;
};
const fixPriceTotalSchema = (schema) => {

    const keys = Object.keys(schema);

    for (let i = 0; i < keys.length; i++) {
        let key = keys[i];
        let child = schema[key];
        if(child?.schema) {
            fixPriceTotalSchema(child?.schema);
        } else if (child.type === 'grid' && child.grid && child.grid.length > 0) {
			for (let j = 0; j < child.grid.length; j++) {
				// let obj = child.grid[j][0][0];
				
				// let sType = obj?.builder?.type;
				// if(key === 'pricetotal' || sType === 'pricetotal') {
				// 	obj.readonly = true;
				// }

                for(let k = 0; k < child.grid[j].length; k++) {
                    let obj = child.grid[j][k][0];
				
                    let sType = obj?.builder?.type;
                    if(key === 'pricetotal' || sType === 'pricetotal') {
                        obj.readonly = true;
                    }
                }
			}
		} else {

            let sType = child?.builder?.type;
            if(key === 'pricetotal' || sType === 'pricetotal') {
				child.readonly = true;
            }
        }
    }
};

const urlQuery = (href, key) => {
    if(href && key) {
        let url = new URL(href);
        let dict = url.searchParams;
        if(dict.has(key)) {
            return dict.get(key);
        }
    }
    return '';

};
const findRedirectUrlFromFormData = (data) => {

    //console.log('[findRedirectUrlFromFormData] data', data);
    let formData = JSON.parse(data.Data);
    //console.log('[findRedirectUrlFromFormData] formData', formData);
    let obj = {
        "key": "redirect_url_do_not_change",
        "value": ""
    };
    findAndDelete(formData, obj);
    data.Data = JSON.stringify(formData);
    //console.log('[findRedirectUrlFromFormData] obj', obj);
    let res = {
        formData: data,
        redirectUrl: obj.value
    };
    //console.log('[findRedirectUrlFromFormData] res', res);
    return res;
};

const isObject = (value) => {
  return Object.prototype.toString.call(value) === '[object Object]';
}
const findAndDelete = (data, obj) => {
	if(isObject(data)) {
		const keys = Object.keys(data);
		if(keys && keys.length > 0) {
			for(let i = 0; i < keys.length; i++) {
				let _key = keys[i];
				if(_key === obj.key) {
					let res = data[_key];
					obj.value = res;
                    //console.log("[findAndDelete] obj", obj);
					delete data[_key];
				} else {
					findAndDelete(data[_key], obj);
				}
			}
		}	
	}
};



const checkFoodForm = (schema) => {
    const keys = Object.keys(schema);
    for(let i = 0; i < keys.length; i ++) {
        let node = schema[keys[i]];
        if(node.name === "foodform" && node.type === "hidden") {
            return true;
        }
    }
    return false;
};
const getFormFields = (data) => {
    const isNested = checkFoodForm(data.schema);
    const node = data || {};
    let fields = {};
    formatSchema(fields, node, null, isNested);
    return fields;
};

const formatSchema = (fields, node, parent, nested) => {
    if (node && node.schema) {
        let keys = Object.keys(node.schema);
        for (let i = 0; i < keys.length; i++) {
            let child = node.schema[keys[i]];

            if (child.schema) {
                if(nested && child.name && child.type === "object") {
                  fields[child.name] = {
                      name: child.name,
                      type: child.type,
                      label: child.description || child.label || child.name,
                      isContainer: true,
                      dict : formatSchemaDict(child.schema)
                  };
                }
                formatSchema(fields, child, child.name, nested);
            } else if (child.type === 'grid' && child.grid && child.grid.length > 0) {
                for (let j = 0; j < child.grid.length; j++) {
                    // let obj = child.grid[j][0][0];
                    // if(obj.name) {
                    //     fields[obj.name] = {
                    //         name: obj.name,
                    //         type: obj.type,
                    //         label: obj.label || obj.name,
                    //         parent: parent
                    //     };

                    // }

					for(let k = 0; k < child.grid[j].length; k++) {
                        let obj = child.grid[j][k][0];
                        if(obj.name) {
                            fields[obj.name] = {
                                name: obj.name,
                                type: obj.type,
                                label: obj.label || obj.name,
                                parent: parent
                            };

                        }
					}
                }
            } else {
                if(child.name) {
                    fields[child.name] = {
                        name: child.name,
                        type: child.type,
                        label: child.label || child.name,
                        parent: parent
                    };

                }
            }

        }
    }
};

const formatSchemaDict = (schema) => {
  let dict = {};
  if(schema) {
    const keys = Object.keys(schema);
    if(keys && keys.length > 0) {
      for(let i = 0; i < keys.length; i++) {
        let child = schema[keys[i]];
        if(child.items) {
          dict[child.name] = formatItemsDict(child.items);
        }
      }
    }
  }
  return dict;
};
const formatItemsDict = (items) => {
  let dict = {};
  if(items && items.length > 0) {
    for(let i = 0; i < items.length; i++) {
      let item = items[i];
      dict[item.value] = item.label || item.value;//item.description || 
    }
  }
  return dict;
};
export { getFormStatus, blobToBase64, base64ToBlob, fileAndBlobToCanvas, formatViewData, formatFormData, findRedirectUrlFromFormData, uploadFiles, getUploadFiles, getFilesData, modifySchema, checkFilesSchema, getPirceInfo, tryFindRedirectUrl, findFieldByPath, setAttrValue, fixPriceSchema, urlQuery };